import { Link } from 'react-router-dom';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <ScrollToTop />
      <span className="font-display text-8xl md:text-[10rem] leading-none text-primary-500 select-none">404</span>
      <h1 className="mt-6 font-display text-2xl md:text-3xl text-foreground-950">
        页面走丢了，就像漫画里失踪的角色
      </h1>
      <p className="mt-3 max-w-md text-sm md:text-base text-foreground-600">
        你访问的页面可能已被移除或链接有误，去首页继续你的漫画之旅吧。
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
      >
        <i className="ri-home-4-line text-base" aria-hidden="true" />
        返回首页
      </Link>
    </div>
  );
}